/** Палец и подпись подсказки: кладётся внутрь цели с `position: relative`, клики не перехватывает. */
import "./hints.css";

/** Палец — тот же рисунок, что у совета в выборе усиления (windows/kit), смотрит вверх; CSS поворачивает к цели. */
function Finger() {
  return (
    <svg width={40} height={40} viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M10 2a2 2 0 0 1 2 2v7l5 1a3 3 0 0 1 2 3v3a5 5 0 0 1-5 5h-2a5 5 0 0 1-4-2l-3-4a1.6 1.6 0 0 1 2.4-2L8 15V4a2 2 0 0 1 2-2z"
        fill="#fff"
        stroke="#1b1f2a"
        stroke-width="1.6"
      />
    </svg>
  );
}

export function HintMark({
  label,
  place = "above",
  testId,
}: {
  label: string;
  place?: "above" | "left";
  testId: string;
}) {
  return (
    <span class={`hint hint--${place}`} data-testid={testId} aria-hidden="true">
      <span class="hint__bubble">{label}</span>
      <span class="hint__finger">
        <Finger />
      </span>
    </span>
  );
}
